import AdvertisementRepository from '../../usecases/ports/AdvertisementRepository';
import { Advertisement } from '../../domain/entities/advertisement';
import { find } from './generic-repository';
import {
  FirebaseFirestore,
  FirestoreCollectionReference,
} from '../../drivers/Firestore';

export default class AdvertisementRepositoryFirebaseImpl
  implements AdvertisementRepository {
  firestore: FirebaseFirestore;
  advertisementRef: FirestoreCollectionReference;

  constructor(
    firestore: FirebaseFirestore,
    adsCollection: string = 'advertisements',
  ) {
    this.firestore = firestore;
    this.advertisementRef = this.firestore.collection(adsCollection);
  }

  fetchAds = async (): Promise<Advertisement[]> => {
    try {
      return (await find(this.advertisementRef, {})) as Advertisement[];
    } catch (error) {
      throw error;
    }
  };
}
